<div class="modal-header">
    <h4 class="modal-title">Nuovo Indice</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="modal-body">
    @if (isLoadingConfig()) {
    <div class="text-center p-3">
        <app-spinner message="Caricamento configurazioni..." />
    </div>
    } @else if (hasError()) {
    <div class="alert alert-danger">
        Errore caricamento configurazioni.
    </div>
    } @else {
    <div class="d-flex flex-column gap-3">
        <div class="mb-3">
            <label for="indexName" class="form-label">Nome Indice</label>
            <input type="text" id="indexName" class="form-control" placeholder="es. marketing_kb_v1"
                [value]="newIndexName()" (input)="onNameChange($event)">
        </div>

        <div class="mb-3">
            <label for="embedderSelect" class="form-label">Modello Embedder</label>
            <select id="embedderSelect" class="form-select" [value]="selectedEmbedder()"
                (change)="onEmbedderChange($event)">
                <option value="" disabled selected>Seleziona Embedder</option>
                @for (emb of availableEmbedders(); track emb.name) {
                <option [value]="emb.name">{{ emb.name }}</option>
                }
            </select>
        </div>

        <div class="mb-3">
            <label for="providerSelect" class="form-label">Provider Vettoriale</label>
            <select id="providerSelect" class="form-select" [value]="selectedProvider()"
                (change)="onProviderChange($event)">
                <option value="" disabled selected>Seleziona Provider</option>
                @for (prov of availableProviders(); track prov.name) {
                <option [value]="prov.name">{{ prov.name }}</option>
                }
            </select>
        </div>
    </div>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="dismiss()">Annulla</button>
    <button type="button" class="btn btn-primary" (click)="confirmCreation()"
        [disabled]="!newIndexName() || !selectedEmbedder() || !selectedProvider() || isCreating()">
        @if (isCreating()) { Creazione... } @else { Crea Indice }
    </button>
</div>